module.exports = __webpack_public_path__ + "bf57393196dc80a6914ef9261f3c7be9.svg";